import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[appZone]",
})
export class ZoneDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
